"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var _state = _interopRequireDefault(require("@/libs/state"));
var _about = _interopRequireDefault(require("./about.html"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let firstRun = true;
const ctor = {
  data: function data() {
    return {
      about_open: false
    };
  },
  computed: {
    networks() {
      return this.$state.networks;
    },
    aboutContent() {
      return _about.default;
    }
  },
  methods: {
    addNetwork() {
      let nick = 'Guest' + Math.floor(Math.random() * 100);
      let network = this.$state.addNetwork(TextFormatting.t('new_network'), nick, {});
      network.showServerBuffer('settings');
    },
    toggleStateBrowser() {
      this.$state.$emit('statebrowser.show');
    },
    async init() {
      this.$state.persistence.watchStateForChanges();
      this.$emit('start', {
        fallbackComponent: this.constructor
      });
    }
  },
  created: async function created() {
    if (firstRun) {
      this.init();
      firstRun = false;
    }
  }
};
var _default = exports.default = ctor;
(0, _state.default)().getStartups().kiwiirccom = ctor;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["thirdparty"]) window._kiwi_exports["thirdparty"] = {};
window._kiwi_exports["thirdparty"]["kiwiirccom"]
window._kiwi_exports.thirdparty.kiwiirccom = exports.default ? exports.default : exports;
